// Generated by scripts/build_waiver_texts.py from waivers/. Do not edit.
export const PORTAL_WAIVER_DOCUMENTS = {
  'fall-2023': 'Fall 2023',
  'winter-2024': 'Winter 2024',
  'spring-2024': 'Spring 2024',
  'spring-2024-open': 'Spring 2024 (Open)',
  'fall-2024': 'Fall 2024',
  'winter-2025': 'Winter 2025',
  'spring-2025': 'Spring 2025',
  'fall-2025': 'Fall 2025',
  'winter-2026': 'Winter 2026',
  'spring-2026': 'Spring 2026',
  'fall-2026': 'Fall 2026',
  'winter-2027': 'Winter 2027',
  'tournament-2026-12': 'December 2026 tournaments',
} as const;

export const WAIVER_DOCUMENTS = {
  ...PORTAL_WAIVER_DOCUMENTS,
} as const;

export type WaiverDocumentId = keyof typeof WAIVER_DOCUMENTS;
export type PortalWaiverDocumentId = keyof typeof PORTAL_WAIVER_DOCUMENTS;

export function isWaiverDocumentId(v: string): v is WaiverDocumentId {
  return Object.hasOwn(WAIVER_DOCUMENTS, v);
}

export function isPortalWaiverDocumentId(
  v: string,
): v is PortalWaiverDocumentId {
  return Object.hasOwn(PORTAL_WAIVER_DOCUMENTS, v);
}
